import { Component, ErrorInfo, ReactNode } from 'react';
import { Box, Typography, Button, Alert, Paper } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import HomeIcon from '@mui/icons-material/Home';
import { Link } from 'react-router-dom';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
    errorInfo: null
  };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error, errorInfo: null };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary yakaladı:', error, errorInfo);
    this.setState({
      error,
      errorInfo
    });
    
    // İsteğe bağlı: Hataları bir hata izleme servisine gönderebilirsiniz
    // logErrorToService(error, errorInfo);
  }

  handleRefresh = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      // Özel fallback UI gelirse onu göster
      if (this.props.fallback) {
        return this.props.fallback;
      }

      // Varsayılan hata görünümü
      return (
        <Box 
          sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            justifyContent: 'center',
            height: '100vh',
            p: 3,
            textAlign: 'center'
          }}
        >
          <Paper elevation={3} sx={{ p: 4, maxWidth: 600, width: '100%' }}>
            <Alert severity="error" sx={{ mb: 2 }}>
              Bir hata oluştu
            </Alert>
            
            <Typography variant="h5" gutterBottom>
              Üzgünüz, bir şeyler ters gitti
            </Typography>
            
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
              Uygulama beklenmeyen bir hatayla karşılaştı. Sayfayı yenileyebilir veya ana sayfaya dönebilirsiniz.
            </Typography>
            
            {this.state.error && (
              <Alert severity="warning" sx={{ mb: 2, textAlign: 'left' }}>
                <Typography variant="body2" component="pre" sx={{ whiteSpace: 'pre-wrap', overflowX: 'auto' }}>
                  {this.state.error.toString()}
                </Typography>
              </Alert>
            )}
            
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 2 }}>
              <Button 
                variant="contained" 
                startIcon={<RefreshIcon />} 
                onClick={this.handleRefresh}
              >
                Sayfayı Yenile
              </Button>
              
              <Button 
                variant="outlined"
                component={Link}
                to="/"
                startIcon={<HomeIcon />}
              >
                Ana Sayfaya Dön
              </Button>
            </Box>
          </Paper>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
